<template>
  <div class="row products">
    <div class="col-lg-3 col-md-4 col-xs-4">
       <div class=" row">
       <div class="fixed" :style="{height: windowHeight - pageTopHeight + 'px'}">
          <div class="table-top" ref="tableTop">
            <el-row>
              <el-col>
                <el-input v-if="mainCategories.length > 0" v-model="filters[0].value" placeholder="Search" class="sm-search col-md-6 icon-search"></el-input>
                <el-input v-else v-model="filters[0].value" placeholder="Search" class="col-md-6 icon-search"></el-input>
                <el-dropdown v-if="mainCategories.length > 0"
                                type="default" class="dropdown-sm" :hide-on-click="false">
                  <el-button type="default" class="filter-btn">
                    <img src="/static/img/icons/filter.png">
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-checkbox-group v-model="filters[1].value" v-on:change="filterChanges()">
                        <template v-for="(loc, key) in mainCategories" >
                          <el-checkbox  :label="loc.id"
                                        :value="loc.id"
                                        :key="loc.id"
                                        > {{loc.name}}
                          </el-checkbox>
                          <br/>
                        </template>
                      </el-checkbox-group>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                 <div class="filters-wrapper">
                  <template v-for="(sts, key) in filters[1].value" >
                    <span class="filter-selection">{{mainCategories[getObjectByElemKeyValue('id', sts, mainCategories)].name}} <a title="Remove filter" href="#" @click.prevent="removeFilter(1, key)"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="table-container" 
                  :style="{height: windowHeight - tableTopHeight - tableBottomHeight - pageTopHeight + 'px'}"
                  ref="tableContainerRef">
          <data-tables class=""
                    v-loading="loading"
                    ref="detailsScrollTable"
                    :current-page="1"
                    :page-size="paginationDef.pageSize"
                    :data="tableData"
                    :action-def="defaultActionDef"
                    :border="false" 
                    :table-props="{'border': false, 'stripe': false, 'row-class-name': rowClass}"
                    :filters="filters"
                    @row-click="goToRecord"
                    style="width: 100%">
        <!--     <template v-for="(catData, catId) in groupedProducts">
              <el-row>
                <el-col col-span="2">
                  {{catData['details']['name']}}
                </el-col>
              </el-row>
            </template>
             -->
            
            <el-table-column
              :min-width="120"
              sortable
              prop="name"
              label="Name">
              <template slot-scope="props">
                <div>{{props.row.name}}</div>
                <div><b>{{ props.row.price_details ? decodeHtml(props.row.price_details.formatted_price) : ''}}</b></div>
                
              </template>
            </el-table-column>
            <el-table-column
              prop="active"
              label="Active">
              <template slot-scope="props">
                <span class="label label-primary mar-bt-15 inline-auto">{{props.row.category.name}}</span><br/>
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>
          </data-tables>
         </div>
         <div class="table-bottom" ref="tableBottom">
            <el-row>
              <el-col>
                <!-- <router-link></router-link> -->
                <a @click.prevent="goToAdd()" class="btn btn-info btn-fill" title=""><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProd.single')}}</a>
              </el-col>
            </el-row>
          </div>
      </div> 
    </div>
    </div>

    <div class="prod-top-bar col-lg-9 col-md-8 col-xs-8" ref="prodTopBar" v-if="showForm()">
      <h6 class="pull-left">{{type}} {{$t('catalogProd.single')}}</h6>
      <div class="text-right">
        <p class="">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn">{{$t('general.save')}}</button>
          <a v-if="isNew()" @click.prevent="handleDelete('cancel')" class="btn btn-danger  btn-fill">{{$t('general.cancel')}}</a>
          <a v-else @click.prevent="handleDelete('delete this product')" class="btn btn-danger btn-fill btn">{{$t('general.delete')}} {{$t('catalogProd.single')}}</a>
        </p>
      </div>
    </div>
 
    <div class="col-lg-9 col-md-8 col-xs-8 detailsScroll" ref="detailsScroll" :style="{height: windowHeight - (pageTopHeight + prodTopBarHeight) + 'px'}">
      <template v-if="showForm()">
        <product-form  v-show="loaded"
                            ref="prodForm" 
                            :mainCategoriesParent="mainCategories"
                            :productsParent="tableData"
                            :productsGroupedParent="groupedProducts"
                            :taxesParent="taxes"
                            :productOptionsParent="productOptions"
                            :callback="updateList"
                            :callbackDelete="getProducts"
        ></product-form>
      </template>
      <div class="no-element" v-if="!showForm()">
        <i class="shopping-cart"></i>
        <div>{{$t('catalogProd.noProducts')}}</div>
      </div>
    </div>
  </div>
</template><script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import ProductForm from './ProductForm.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      ProductForm
    },
    computed: {
    },
    data () {
      return {
        type: '',
        loaded: false,
        loading: true,
        paginationDef: {
          pageSize: 9999,
          currentPage: 1,
          pageSizes: [99999],
          show: false
        },
        searchQuery: '',
        propsToSearch: ['name', 'price', 'status'],
        tableColumns: [],
        tableData: [],
        groupedProducts: [],
        mainCategories: [],
        productOptions: [],
        taxes: [],
        windowHeight: 0,
        tableTopHeight: 70,
        tableBottomHeight: 63,
        prodTopBarHeight: 70,
        pageTopHeight: 0,
        filters: [
          {
            value: '',
            prop: ['name', 'price']
          },
          {
            value: [],
            prop: ['category'],
            filterFn: (row, filter) => {
              this.$nextTick(() => {
                this.tableTopHeight = this.$refs.tableTop.clientHeight
              })
              return this.isInObject(row['category']['id'], filter.value)
            }
          }
        ]
      }
    },
    watch: {
      windowHeight (newHeight, oldHeight) {
        // console.warn(`it changed to ${newHeight} from ${oldHeight}`)
      }
    },
    created: function () {
      var self = this
      this.getProducts()
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1
      }
      this.apiRequest('/settings/taxes', 'GET', data, function (response) {
        if (response.status === true) {
          self.taxes = response.data
        }
      })
      this.apiRequest('/settings/general/' + data['company_id'], 'GET', data, function (response) {
        if (response.status === true) {
          self.productOptions = response.data[0].products_options
        }
      })
      // get main categories
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          self.mainCategories = response.data
        }
      })
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      showForm () {
        if (this.$route.path.indexOf('edit') !== -1 || this.$route.path.indexOf('add') !== -1) {
          return true
        } else {
          return false
        }
      },
      isNew () {
        if (this.$route.params.id && this.$route.params.id !== 'add') {
          this.type = this.$t('general.edit')
          return false
        } else {
          this.type = this.$t('general.add')
          return true
        }
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
        this.tableBottomHeight = (this.$refs.tableBottom && this.$refs.tableBottom.clientHeight) ? this.$refs.tableBottom.clientHeight : 0
        this.prodTopBarHeight = this.$refs.prodTopBar ? this.$refs.prodTopBar.clientHeight + 1 : 0
        if (window.innerWidth < 1200) {
          this.pageTopHeight = 75
        } else {
          this.pageTopHeight = 0
        }
      },
      filterChanges (data) {
        this.doHeightCalculation()
      },
      goToAdd () {
        this.$router.push('/products/add')
        this.$refs.prodForm.getData()
        this.$refs.prodForm.getTrees()
        this.doHeightCalculation()
      },
      getProducts () {
        this.loading = true
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1
        }
        var data2 = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          grouped: 1
        }
        // this.apiRequest('/product', 'GET', data, function (response) {
        //   if (response.status === true) {}
        // })
        this.apiRequest('/product', 'GET', data2, function (response) {
          if (response.status === true) {
            var formattedProds = []
            var prods = response.data

            for (var idCateg in prods) {
              if (prods[idCateg].items.length) {
                // formattedProds.push({
                //   is: prods[idCateg].details.id,
                //   name: prods[idCateg].details.name
                // })
                formattedProds = formattedProds.concat(prods[idCateg].items)
              }
            }
            self.tableData = formattedProds

            self.paginationDef.pageSize = self.tableData.length + 1

            // scroll to element
            if (!self.isNew()) {
              self.$nextTick(function () {
                let el = self.$el.getElementsByClassName('current')[0]
                var container = self.$refs.tableContainerRef
                var table = self.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody')
                var position = 1

                for (var i = 0; i < table.children.length; i++) {
                  if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                    if (i > 1) {
                      position = i
                    }
                  }
                }
                container.scrollTo({
                  left: 0,
                  top: el.clientHeight * position,
                  behavior: 'smooth'
                })
              })
            }

            self.groupedProducts = response.data
            self.loaded = true
          }
          self.$nextTick(function () {
            self.loading = false
          })
        })
      },
      goToRecord (row, event, column) {
        // this.$nextTick(function () {
        this.globalGoToRecord(row, event, column, '/products/edit/')
        if (this.$refs.prodForm) {
          this.$refs.prodForm.getData()
        }
        this.$nextTick(() => {
          this.doHeightCalculation()
        })
        // })
      },
      handleActive (index, row, e) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: `${this.$t('validations.areYouSureYouWantTo')} ${actionText} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              id: row.id,
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: row.active ? 1 : 0
            }
            this.apiRequest('/product/' + row.id, 'PUT', data, function (response) {
              if (response.status) {
                swal(
                  this.$t('general.success') + '!',
                  '',
                  'success'
                )
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                )
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
          row.active = !row.active
        })
      },
      rowClass (row, index) {
        if (this.$route.params.id && (parseInt(row.row.id) === parseInt(this.$route.params.id))) {
          return 'current'
        } else {
          return ''
        }
      },
      handleDelete (label) {
        this.$refs.prodForm.handleDelete(label)
      },
      validate () {
        this.$refs.prodForm.validate()
      },
      removeFilter (filterKey, key) {
        Vue.delete(this.filters[filterKey].value, key)
        this.$nextTick(() => {
          this.tableTopHeight = this.$refs.tableTop.clientHeight
        })
      },
      updateList (id, data) {
        let idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData)

        if (idx) {
          this.tableData[idx]['name'] = data['name']
          this.tableData[idx]['price'] = data['price']
          this.tableData[idx]['active'] = data['active']
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.filters-wrapper {
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/Products.vue